module.exports = __webpack_public_path__ + "media/images/phi_interns-f8027204a5375eb78d5a2b878da9629b.jpg";